"use strict";
exports.__esModule = true;
exports.EMBED_DEFAULT_MODAL = exports.EMBED_MANUAL_TOO_MANY_ATTEMPTS_MODAL = void 0;
exports.EMBED_MANUAL_TOO_MANY_ATTEMPTS_MODAL = {
    BODY: 'You attempted this action too quickly. Please wait a few moments and try again.',
    CTA: 'Done',
    HEADER: 'Too many attempts'
};
exports.EMBED_DEFAULT_MODAL = {
    BODY: 'We weren’t able to complete your request. Please try again.',
    CTA: 'OK',
    HEADER: 'Error'
};
